import { render, staticRenderFns } from "./setsignature.vue?vue&type=template&id=06de69b4&scoped=true"
import script from "./setsignature.vue?vue&type=script&lang=js"
export * from "./setsignature.vue?vue&type=script&lang=js"
import style0 from "./setsignature.vue?vue&type=style&index=0&id=06de69b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de69b4",
  null
  
)

export default component.exports